window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);

function videoScroll() {

  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    let windowHeight = window.innerHeight,
        videoEl = document.querySelectorAll('video[autoplay]');

    for (let i = 0; i < videoEl.length; i++) {

      const thisVideoEl = videoEl[i],
      //要素の高さ
      videoHeight = thisVideoEl.clientHeight,
      //画面上橋から要素までの高さ
      videoClientRect = thisVideoEl.getBoundingClientRect().top;

      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }

    }
  }

}
